const utilStore = {
  state: () => ({
    isCheckTerms: false,
    isRefreshed: false,
  }),

  mutations: {
    isCheckTerms: (state, payload) => {
      state.isCheckTerms = payload;
    },
    isRefreshed: (state, payload) => {
      state.isRefreshed = payload;
    },
  },
};

export default utilStore;
